import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import React from "react"
import Route from "@kaspernj/api-maker/build/router/route"
import Switch from "@kaspernj/api-maker/build/router/switch"
import {useWoofRouter} from "shared/woof-router"
/** @typedef {object} RoutesAdminSubscriptionsRouteProps */

/** @typedef {object} RoutesAdminSubscriptionsRouteState */

/**
 * @extends {ShapeComponent<RoutesAdminSubscriptionsRouteProps, RoutesAdminSubscriptionsRouteState>}
 */
class RoutesAdminSubscriptionsRoute extends ShapeComponent {
  setup() {
    this.woofRouter = useWoofRouter()
  }

  render() {
    return (
      <Switch name="subscriptions">
        <Route component="index" exact />
        <Route component="edit" exact path="new" />
        <Route component="edit" exact path=":subscription_id/edit" />
        <Route component="periods" exact path=":subscription_id/periods" />
        <Route component="show" exact path=":subscription_id" />
        <Route componentPath="fallback" fallback onMatch={this.tt.onFallbackMatch} />
      </Switch>
    )
  }

  onFallbackMatch = () => this.woofRouter.setPageNotFound(true)
}

export default memo(shapeComponent(RoutesAdminSubscriptionsRoute))
